

import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { namespace } from "vuex-class";

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form3";
const form3State = namespace("Form3");

import { form3DataInfoType, partyInfoType } from '@/types/Information/Form3';
import { partiesDataJsonDataType, previousCourtJsonInfoType } from '@/types/Information/json';
import AddPartyForm from './AddPartyForm.vue';
import { partiesContact } from '@/types/Information';

@Component({
    components:{        
        AddPartyForm        
    }
})
export default class Form3StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @informationState.State
    public previousCourts: previousCourtJsonInfoType[]

    @informationState.State
    public fileNumber: string;

    @form3State.State
    public form3Info: form3DataInfoType;

    @form3State.Action
    public UpdateForm3Info!: (newForm3Info: form3DataInfoType) => void  
    
    @form3State.State
    public currentNoticeOfCrossAppealId: string;

    @form3State.Action
    public UpdateCurrentNoticeOfCrossAppealId!: (newCurrentNoticeOfCrossAppealId: string) => void
    
    dataReady = false;
    updated=0; 
    updateOrderDetails = 0;
    orderDateValue = '';
    
    showNoneBcAlert=false

    addRespondentFormColor = 'court';
    AddNewRespondentForm = false;
    latestEditRespondentData;
    isEditRespondentOpen = false;

    addAppellantFormColor = 'court';
    AddNewAppellantForm = false;
    latestEditAppellantData;
    isEditAppellantOpen = false;
    
    yesNoOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    partyFields = [
        {
            key:'organization',          
            label:'Party Type',                  
            thClass: 'text-white bg-court',
            thStyle: 'font-size: 1rem;',            
            sortable:false            
        }, 
        {
            key:'name',          
            label:'Party Name',   
            thClass: 'text-white bg-court', 
            thStyle: 'font-size: 1rem;',          
            sortable:false            
        }, 
        {
            key:'edit',          
            label:'',   
            thClass: 'text-white bg-court',           
            sortable:false            
        }        
    ]

    state = { 
        appellants: null,
        respondents: null,
        formSevenNumber: null,
        orderDate: null,
        judgeName: null,
        crossAppealRequired:null,
        amending: null,
        crossAppealingParties:null,
        partOfOrderCrossAppealed:null,
        seekingOrder:null,
        partOfOrderLeaveCrossAppealed:null,
        groundsLeaveCrossAppeal:null,       
        phoneNumbers:null,        
        addresses:null,               
        authorizedName:null, 
        selfRepresenting: null,
        email:null,
        nonBcAddress: null
    }

    mounted() {
        this.dataReady = false;        
        this.extractInfo();              
    }

    public partyDataExists(){

        const existsManual = this.form3Info.requiresManualEntry && 
            this.form3Info.manualAppellants.length>0 && 
            this.form3Info.manualRespondents.length>0;

        const existsSupreme = !this.form3Info.requiresManualEntry && 
            this.form3Info.appellants.length>0 && 
            this.form3Info.respondents.length>0;
            
        return existsManual || existsSupreme;
    }

    public updateOrderDate(){       
        this.form3Info.orderDate = this.orderDateValue;
        this.recheckStates()
        this.updateOrderDetails ++;
    }

    public extractInfo(){       

        if(this.currentNoticeOfCrossAppealId){
            this.getForm3Data();
           
        } else { 

            const form3Data = this.form3Info;
            form3Data.crossAppealRequired = true;
            form3Data.version = this.$store.state.Application.version;
            form3Data.manualRespondents = [];
            form3Data.manualAppellants = [];
            form3Data.crossAppealingParties = [];
            form3Data.addresses = [];
            form3Data.emailAdresses = [];
            form3Data.phoneNumbers = [];

            if (this.form3Info?.requiresManualEntry){
                
                form3Data.appellants = [];
                form3Data.respondents = [];
                form3Data.appellantNames = '';
                form3Data.respondentNames = '';
                form3Data.formSevenNumber = ''; 
                form3Data.judgeName = '' 
                form3Data.orderDate = '';

            } else {               

                let applicantNames = [];
                let respondentNames = [];               

                form3Data.appellants = this.partiesJson.appellants
                form3Data.respondents = this.partiesJson.respondents;

                for (const respondent of form3Data.respondents){
                    respondentNames.push(respondent.name);                
                }

                for (const applicant of form3Data.appellants){
                    applicantNames.push(applicant.name);                
                }

                form3Data.appellantNames = applicantNames.join(', ');
                form3Data.respondentNames = respondentNames.join(', ');      
                      
                form3Data.formSevenNumber = this.fileNumber;

                form3Data.judgeName = this.previousCourts[0]?.JudgeSalutation + ' ' + Vue.filter('getFullName')(this.previousCourts[0]?.JudgeFirstName, this.previousCourts[0]?.JudgeLastName) 
                const orderDate = this.previousCourts[0]?.JudgmentDate?this.previousCourts[0].JudgmentDate.slice(0,10):'';
                form3Data.orderDate = orderDate;
                this.orderDateValue = orderDate;                
            }
            this.UpdateForm3Info(form3Data);
            
            this.saveForm(true);
        }            

    }

    get partyNames(){
        
        let partyNames: string[] = [];

        if (this.form3Info.requiresManualEntry){

            for (const respondent of this.form3Info.manualRespondents){
                partyNames.push(respondent.name) 
            }

            for (const applicant of this.form3Info.manualAppellants){
                partyNames.push(applicant.name);  
            }

        } else {

            for (const respondent of this.form3Info.respondents){
                partyNames.push(respondent.name) 
            }

            for (const applicant of this.form3Info.appellants){
                partyNames.push(applicant.name);  
            }
        }      
        return partyNames;
    }  

    get isPastDeadline(){

        const today = new Date();
        const orderDate = new Date(this.form3Info.orderDate);

        const TimePast = today.getTime() - orderDate.getTime();
        const daysPast = TimePast / (1000 * 3600 * 24);        
        
        return daysPast > 30;
    }

    public updateAddressFields(){

        const formData = this.form3Info;
        const addressData = formData.addresses;
        const addresses: partiesContact[] = []; 
        const emailData = formData.emailAdresses;
        const emails: partiesContact[] = []; 
        const phoneData = formData.phoneNumbers;
        const phoneNumbers: partiesContact[] = []; 

        for (const partyName of this.form3Info.crossAppealingParties){
           
            const matchingAddressRecords = addressData.filter(address => address.name == partyName);

            if (matchingAddressRecords.length == 0){
                addresses.push({name: partyName, contactInfo: ''});
            } else {                
                const index = addressData.findIndex(address => address.name == matchingAddressRecords[0].name);               
                addresses.push(addressData[index]);
            }

            const matchingPhoneRecords = phoneData.filter(phone => phone.name == partyName); 
            
            if (matchingPhoneRecords.length == 0){
                phoneNumbers.push({name: partyName, contactInfo: ''});
            } else {                
                const index = phoneData.findIndex(phone => phone.name == matchingPhoneRecords[0].name);               
                phoneNumbers.push(phoneData[index]);
            }

            const matchingEmailRecords = emailData.filter(email => email.name == partyName); 
            
            if (matchingEmailRecords.length == 0){
                emails.push({name: partyName, contactInfo: ''});
            } else {                
                const index = emailData.findIndex(email => email.name == matchingEmailRecords[0].name);               
                emails.push(emailData[index]);
            }
        }

        formData.addresses = addresses;
        formData.emailAdresses = emails;
        formData.phoneNumbers = phoneNumbers;
        this.UpdateForm3Info(formData)
        this.recheckStates();
        this.updated ++;               
    }

    public getForm3Data() {        
       
        this.$http.get('/form3/forms/'+this.currentNoticeOfCrossAppealId)
        .then((response) => {
            if(response?.data?.data){
                const form3Data = response.data.data   
                this.orderDateValue = form3Data.orderDate? form3Data.orderDate.slice(0,10): '';             
                this.UpdateForm3Info(form3Data);
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

    public clearStates(){
        this.state = {
            appellants: null,
            respondents: null,
            formSevenNumber: null,
            orderDate: null,
            judgeName: null,
            crossAppealRequired:null,
            amending: null,
            crossAppealingParties:null,
            partOfOrderCrossAppealed:null,
            seekingOrder:null,
            partOfOrderLeaveCrossAppealed:null,
            groundsLeaveCrossAppeal:null,       
            phoneNumbers:null,
            addresses:null,               
            authorizedName:null,
            selfRepresenting: null,
            email:null,
            nonBcAddress: null
        }
        this.dataReady = true; 
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){   

        if(this.form3Info.requiresManualEntry){
            this.state.appellants = this.form3Info.manualAppellants?.length>0? null :false;
            this.state.respondents = this.form3Info.manualRespondents?.length>0? null :false;
        } else {
            this.state.appellants = null;
            this.state.respondents = null;
        }

        this.state.formSevenNumber = this.form3Info.formSevenNumber?.trim().length>0? null:false;
        this.state.orderDate = this.form3Info.orderDate? null:false;
        this.state.judgeName = this.form3Info.judgeName? null:false;        
        this.state.crossAppealRequired = this.form3Info.crossAppealRequired != null? null:false;
        this.state.amending = this.form3Info.amending != null? null:false;
        this.state.crossAppealingParties = this.form3Info.crossAppealingParties?.length>0? null :false;
        this.state.partOfOrderLeaveCrossAppealed = (this.form3Info.crossAppealRequired && !this.form3Info.partOfOrderLeaveCrossAppealed)? false: null;
        this.state.groundsLeaveCrossAppeal = (this.form3Info.crossAppealRequired && !this.form3Info.groundsLeaveCrossAppeal)? false: null;
        this.state.partOfOrderCrossAppealed = (!this.form3Info.crossAppealRequired && !this.form3Info.partOfOrderCrossAppealed)? false: null;
        this.state.seekingOrder = (!this.form3Info.crossAppealRequired && !this.form3Info.seekingOrder)? false: null;
        this.state.phoneNumbers = !(this.form3Info.phoneNumbers && this.verifyPhoneNumbers()
                                    && this.form3Info.phoneNumbers.length == this.form3Info.crossAppealingParties.length)? false : null;
         
        const verifiedAddresses = this.verifyAddresses()
        this.state.addresses = verifiedAddresses.valid;
        this.state.nonBcAddress = verifiedAddresses.nonBC;

        this.state.email = this.verifyEmails()? null: false;

        this.state.authorizedName = !this.form3Info.authorizedName? false : null;
        this.state.selfRepresenting = this.form3Info.selfRepresenting != null? null: false;

        for(const field of Object.keys(this.state)){            
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    }   
    
    public verifyPhoneNumbers(){
        for(const phoneNumber of this.form3Info.phoneNumbers){            
            if(!Vue.filter('verifyPhone')(phoneNumber.contactInfo))            
                return false;
        }
        return true;
    }

    public verifyEmails(){
        for(const email of this.form3Info.emailAdresses){
            if(email.contactInfo && !Vue.filter('verifyEmail')(email.contactInfo))
                return false
        }
        return true
    }

    public verifyAddresses(){
        let nonBC = null
        for(const index in this.form3Info.addresses){ 
            const address = this.form3Info.addresses[index]
            const verifiedAddress = Vue.filter('verifyAddress')(address.contactInfo)
            
            if(verifiedAddress=='EMPTY' && (!this.form3Info.emailAdresses[index].contactInfo || !Vue.filter('verifyEmail')(this.form3Info.emailAdresses[index].contactInfo)))                  
                return {valid:false, nonBC:null};
            if(verifiedAddress=='ERR')
                return {valid:false, nonBC:null};
            if(verifiedAddress=='NONE_BC') nonBC = true
        }
        return {valid:null, nonBC:nonBC};
    }

    public extractAddresses(){
        const addresses = [];
        for(const contactAddress of this.form3Info.addresses){            
            if(contactAddress.contactInfo.trim().length != 0){
                addresses.push(contactAddress.name + ': ' + contactAddress.contactInfo.trim());
            }  
        }
        return addresses.join('<br>');        
    }

    public extractPhoneNumbers(){
        const phoneNumbers = [];
        for(const phone of this.form3Info.phoneNumbers){            
            if(phone.contactInfo.trim().length != 0){
                phoneNumbers.push(phone.name + ': ' + phone.contactInfo.trim());
            }  
        }
        return phoneNumbers.join('<br>');        
    }

    public extractEmails(){
        const emails = [];
        for(const email of this.form3Info.emailAdresses){            
            if(email.contactInfo.trim().length != 0){
                emails.push(email.name + ': ' + email.contactInfo.trim());
            }  
        }
        return emails.join('<br>');        
    }


    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form3/forms';

        if (this.currentNoticeOfCrossAppealId){
            method = 'put';
            url = '/form3/forms/'+this.currentNoticeOfCrossAppealId;
            const form3Data = this.form3Info;
            form3Data.contactAddress = this.extractAddresses();
            form3Data.emails = this.extractEmails();
            form3Data.phones = this.extractPhoneNumbers();
            this.UpdateForm3Info(form3Data);

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form3Info,
                    type:'Form3',
                    description:'Notice of Cross Appeal'
                }
            }
            this.saveInfo(options, draft);

        } else {
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form3Info,
                    type:'Form3',
                    description:'Notice of Cross Appeal'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentNoticeOfCrossAppealId(response.data.file_id); 
                    }

                    this.clearStates();                                     
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }

    public addNewRespondent(){
        if(this.isEditRespondentOpen){            
            this.addRespondentFormColor = 'danger'
        }else{
            this.AddNewRespondentForm = true;            
        }
    }

    public editRespondent(data) {
        if(this.AddNewRespondentForm || this.isEditRespondentOpen){            
            this.addRespondentFormColor = 'danger';                     
        }else if(!this.isEditRespondentOpen && !data.detailsShowing){
            data.toggleDetails();
            this.isEditRespondentOpen = true;
            this.latestEditRespondentData = data            
        }   
    }

    public modifyRespondentList(isCreateParty: boolean, newParty: partyInfoType, index: number){        

        if (isCreateParty){

            if (!newParty.organization){
                newParty.name = newParty.firstName + ' ' + newParty.lastName;
            }

            const respondentNames = []
            const form3Data = this.form3Info;
            form3Data.manualRespondents.push(newParty)

            for (const respondent of form3Data.manualRespondents){
                respondentNames.push(respondent.name);                
            }
            form3Data.respondentNames = respondentNames.join(', '); 
            this.UpdateForm3Info(form3Data)

            this.closeRespondentForm();

        } else {  

            if (!newParty.organization){
                newParty.name = newParty.firstName + ' ' + newParty.lastName;
            }  
            
            const respondentNames = [];
            const form3Data = this.form3Info;
            form3Data.manualRespondents[index].organization = newParty.organization;
            form3Data.manualRespondents[index].name = newParty.name; 
            form3Data.manualRespondents[index].firstName = newParty.firstName;
            form3Data.manualRespondents[index].lastName = newParty.lastName;

            for (const respondent of form3Data.manualRespondents){
                respondentNames.push(respondent.name);                
            }
            form3Data.respondentNames = respondentNames.join(', '); 
            this.UpdateForm3Info(form3Data);
                      
            this.closeRespondentForm();
        }
        this.updated ++;
    }

    public removeRespondent(data){ 
        const form3Data = this.form3Info;       
        form3Data.manualRespondents.splice(data.index,1);
        const respondentNames = [];
        for (const respondent of form3Data.manualRespondents){
            respondentNames.push(respondent.name);                
        }
        form3Data.respondentNames = respondentNames.join(', '); 
        this.UpdateForm3Info(form3Data);
        this.updated ++;        
    }

    public closeRespondentForm() {                     
        this.AddNewRespondentForm= false; 
        this.addRespondentFormColor = 'court'
        if(this.isEditRespondentOpen){
            this.latestEditRespondentData.toggleDetails();
            this.isEditRespondentOpen = false;
        } 
    }

    public addNewAppellant(){
        if(this.isEditAppellantOpen){            
            this.addAppellantFormColor = 'danger'
        }else{
            this.AddNewAppellantForm = true;            
        }
    }

    public editAppellant(data) {
        if(this.AddNewAppellantForm || this.isEditAppellantOpen){            
            this.addAppellantFormColor = 'danger';                     
        }else if(!this.isEditAppellantOpen && !data.detailsShowing){
            data.toggleDetails();
            this.isEditAppellantOpen = true;
            this.latestEditAppellantData = data            
        }   
    }
    
    public modifyAppellantList(isCreateParty: boolean, newParty: partyInfoType, index: number){        

        if (isCreateParty){ 

            if (!newParty.organization){
                newParty.name = newParty.firstName + ' ' + newParty.lastName;
            }    

            const appellantNames = []
            const form3Data = this.form3Info;
            form3Data.manualAppellants.push(newParty)

            for (const appellant of form3Data.manualAppellants){
                appellantNames.push(appellant.name);                
            }
            form3Data.appellantNames = appellantNames.join(', '); 
            this.UpdateForm3Info(form3Data);

            this.closeAppellantForm();
        } else {  

            if (!newParty.organization){
                newParty.name = newParty.firstName + ' ' + newParty.lastName
            } 
            
            const appellantNames = [];
            const form3Data = this.form3Info;
            form3Data.manualAppellants[index].organization = newParty.organization;
            form3Data.manualAppellants[index].name = newParty.name; 
            form3Data.manualAppellants[index].firstName = newParty.firstName;
            form3Data.manualAppellants[index].lastName = newParty.lastName;

            for (const appellant of form3Data.manualAppellants){
                appellantNames.push(appellant.name);                
            }
            form3Data.appellantNames = appellantNames.join(', '); 
            this.UpdateForm3Info(form3Data);  
            this.closeAppellantForm();
        }
        this.updated ++;
        
    }

    public removeAppellant(data){   
        const form3Data = this.form3Info;       
        form3Data.manualAppellants.splice(data.index,1);
        const appellantNames = [];
        for (const appellant of form3Data.manualAppellants){
            appellantNames.push(appellant.name);                
        }
        form3Data.appellantNames = appellantNames.join(', '); 
        this.UpdateForm3Info(form3Data);
        this.updated ++;        
    }

    public closeAppellantForm() {                     
        this.AddNewAppellantForm= false; 
        this.addAppellantFormColor = 'court'
        if(this.isEditAppellantOpen){
            this.latestEditAppellantData.toggleDetails();
            this.isEditAppellantOpen = false;
        } 
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');
        return (date <= day);           
    }
   
    public navigateToPreviewPage() {          
        if (this.checkStates()){
            if(this.state.nonBcAddress)
               this.showNoneBcAlert=true
            else
                this.$router.push({name: "preview-form3"});
        }        
    }

    public confirmNavigateToPreviewPage(){
        this.showNoneBcAlert=false
        this.$router.push({name: "preview-form3"});
    }

}
